export const createUOM = /* GraphQL */ `
  mutation CreateUOM($name: String!, $abbreviation: String!, $description: String!) {
    createUnitOfMeassure(input: { name: $name, abbreviation: $abbreviation, description: $description }) {
      id
      _version
      _deleted
    }
  }
`;
